import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "location-delivery-wrapper",
  "data-cy": "delivery-section"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_orderTypeToggle = _resolveComponent("orderTypeToggle")!
  const _component_addressList = _resolveComponent("addressList")!
  const _component_addressForm = _resolveComponent("addressForm")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_locationDeliveryErrorCard = _resolveComponent("locationDeliveryErrorCard")!
  const _component_locationDeliveryCard = _resolveComponent("locationDeliveryCard")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_orderTypeToggle, {
      showToolbar: !_ctx.isMobile,
      modelValue: _ctx.isDelivery,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDelivery) = $event)),
      "data-cy": "order-toggle"
    }, null, 8, ["showToolbar", "modelValue"]),
    _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "ion-margin-start bold color-black" }, "Deliver to", -1)),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createBlock(_component_addressList, {
          key: 0,
          addresses: _ctx.deliveryAddresses,
          selectable: "",
          editable: "",
          deleteable: "",
          addBtn: "",
          onUpdateShowAddressForm: _ctx.updateShowAddressForm,
          onSelected: _ctx.selectDeliveryAddress
        }, null, 8, ["addresses", "onUpdateShowAddressForm", "onSelected"]))
      : (!_ctx.foundAddress)
        ? (_openBlock(), _createBlock(_component_addressForm, {
            key: 1,
            submitBtnText: "Find My Delivery Store",
            submitFunction: _ctx.validate,
            initialValues: _ctx.getSearchedDeliveryAddress,
            onUpdatingAddress: _ctx.updatingAddress,
            onChangePickup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changePickup')))
          }, null, 8, ["submitFunction", "initialValues", "onUpdatingAddress"]))
        : (_openBlock(), _createBlock(_component_ion_row, {
            key: 2,
            class: "compressed-address ion-justify-content-between ion-align-items-center ion-align-content-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "10" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.getSearchedDeliveryAddress.address1) + " " + _toDisplayString(_ctx.getSearchedDeliveryAddress.address2), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getSearchedDeliveryAddress.city) + ", " + _toDisplayString(_ctx.getSearchedDeliveryAddress.state) + " " + _toDisplayString(_ctx.getSearchedDeliveryAddress.zip), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "2",
                style: {"cursor":"pointer","text-align":"center","margin-top":"5px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.closeOutline,
                    class: "bold-icon",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.foundAddress = false))
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
    (_ctx.errorMsg)
      ? (_openBlock(), _createBlock(_component_locationDeliveryErrorCard, {
          key: 3,
          isMobile: "",
          errorMsg: _ctx.errorMsg,
          deliveryAddress: _ctx.searchedAddress,
          class: "ion-margin-bottom",
          onChangePickup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('changePickup')))
        }, null, 8, ["errorMsg", "deliveryAddress"]))
      : _createCommentVNode("", true),
    (_ctx.showDeliveryInfo)
      ? (_openBlock(), _createBlock(_component_locationDeliveryCard, {
          key: 4,
          isDelivery: "",
          isMobile: "",
          storeLocation: _ctx.getDisplayDeliveryStore,
          deliveryAddress: _ctx.getSearchedDeliveryAddress,
          class: "ion-margin-bottom",
          style: {"margin-bottom":"80px"},
          isDeliveryTurnedOff: _ctx.isDeliveryTurnedOff,
          isDeliveryTurnedOn: !_ctx.isDeliveryTurnedOff,
          isStoreOpen: _ctx.isStoreOpen,
          onDeliverHere: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectLocation(_ctx.getDisplayDeliveryStore.id))),
          onChangePickup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('changePickup')))
        }, null, 8, ["storeLocation", "deliveryAddress", "isDeliveryTurnedOff", "isDeliveryTurnedOn", "isStoreOpen"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_row, { class: "ion-no-margin force-bottom full-width z-top" }, {
      default: _withCtx(() => [
        (_ctx.showDeliveryInfo)
          ? (_openBlock(), _createBlock(_component_ion_button, {
              key: 0,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectLocation(_ctx.getDisplayDeliveryStore.id))),
              color: "primary",
              expand: "full",
              class: "ion-no-margin force-bottom full-width z-top",
              size: "large",
              "data-cy": "button-delivery-here",
              id: "button-delivery-here",
              disabled: _ctx.processingNearLocations || _ctx.showAddAddressForm || _ctx.isSubmitDisabled || _ctx.isDeliveryTurnedOff
            }, {
              default: _withCtx(() => [
                (_ctx.state.isDeliveryLoading)
                  ? (_openBlock(), _createBlock(_component_ion_spinner, {
                      key: 0,
                      name: "lines-small"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.isRedRobinStore ? 'Order at Red Robin' : 'Deliver here'), 1))
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}